import axios from "./axios";

export const inventoryCorrectionsApi = {
  // Get all inventory corrections
  getInventoryCorrections: async (params = {}) => {
    return axios.get("/inventory/corrections", { params });
  },

  // Get a single inventory correction by ID
  getInventoryCorrection: async (id) => {
    return axios.get(`/inventory/corrections/${id}`);
  },

  // Create a new inventory correction
  createInventoryCorrection: async (data) => {
    return axios.post("/inventory/corrections", {
      inventory_correction: data,
    });
  },

  // Update an existing inventory correction
  updateInventoryCorrection: async (id, data) => {
    return axios.put(`/inventory/corrections/${id}`, {
      inventory_correction: data,
    });
  },

  // Delete an inventory correction
  deleteInventoryCorrection: async (id) => {
    return axios.delete(`/inventory/corrections/${id}`);
  },

  // Approve an inventory correction
  approveInventoryCorrection: async (id, comment = "") => {
    return axios.post(`/inventory/corrections/${id}/approve`, {
      approval_comment: comment,
    });
  },

  // Reject an inventory correction
  rejectInventoryCorrection: async (id, comment = "") => {
    return axios.post(`/inventory/corrections/${id}/reject`, {
      approval_comment: comment,
    });
  },

  // Submit inventory correction for approval
  submitInventoryCorrectionForApproval: async (id) => {
    return axios.post(`/inventory/corrections/${id}/submit_for_approval`);
  },

  // Add item to inventory correction
  addItemToCorrection: async (correctionId, data) => {
    return axios.post(`/inventory/corrections/${correctionId}/items`, {
      inventory_correction_item: data,
    });
  },

  // Update item in inventory correction
  updateItemInCorrection: async (correctionId, itemId, data) => {
    return axios.put(`/inventory/corrections/${correctionId}/items/${itemId}`, {
      inventory_correction_item: data,
    });
  },

  // Remove item from inventory correction
  removeItemFromCorrection: async (correctionId, itemId) => {
    return axios.delete(`/inventory/corrections/${correctionId}/items/${itemId}`);
  },
};

